<template>
  <v-container fluid class="mx-0 px-0">
    <!-- <v-card class="ntr-card-gray pa-2 pb-1" flat>
      <v-card flat class="ntr-card-dark pa-1 mb-2">
        <v-card class="ntr-card-white pa-2" flat> -->
    <el-button-prideti
      class="mb-3"
      v-if="showAddRinkmenos"
      small
      @click.native.stop="newItem()"
    >
      {{ $t('Prisegti rinkmeną') }}
    </el-button-prideti>

    <el-button
      class="mb-3"
      v-if="showUzsakytiSklypa"
      small
      @click.native.stop="newZemesSklypas()"
    >
      {{ $t('Užsakyti žemės sklypo planą') }}
    </el-button>

    <v-data-table
      :headers="filteredHeaders"
      :items="itemsList"
      :loading="loading"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: this.$t('Rodyti po:'),
        itemsPerPageAllText: this.$t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :hide-default-footer="hideFooter"
      :items-per-page="pageSize"
    >
      <template #[`item.byl_rusis`]="{ item }">
        <div class="nowrap">
          {{ item.byl_rusis }}
        </div>
        <div class="nowrap text-gray" v-if="item.sklypo_turtas">
          {{ item.sklypo_turtas }}
        </div>
      </template>
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            @editItem="editItem(item)"
            @deleteItem="deleteItem(item)"
            @restoreItem="restoreItem(item)"
          />
        </div>
        <el-button
          v-if="item.canUpload"
          small
          :loading="loading"
          @click.native="openUpload(item)"
          >{{ $t('Prisegti') }}</el-button
        >
      </template>
      <template slot="loading">
        {{ $t('Kraunasi...') }}
      </template>
      <template slot="no-results">
        {{ $t('Duomenų nėra') }}
      </template>
      <template slot="no-data">
        {{ $t('Duomenų nėra') }}
      </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>

    <modal-ntr-upload
      v-model="showUpload"
      :upload="modalUpload"
      :key="modalUploadKey"
      :multiple="false"
      :bylos-rusys="modalBylosRusys"
      :max-dydis="rinkmenaDydis"
      @savedData="savedUpload"
    />

    <modal-delete
      :title="$t('Šalinti rinkmeną?')"
      :text="
        $t('Ar norite pašalinti rinkmeną') +
          ` <strong>${modalDeleteVardas}</strong>?`
      "
      v-model="showDelete"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import busena from '@/mixins/busenaNtr'
import ModalNtrUpload from '../modals/ModalNtrUpload'
import ModalDelete from '../modals/ModalDelete'

export default {
  name: 'PrasymasUpload',
  components: {
    ModalNtrUpload,
    ModalDelete,
  },
  mixins: [userRole, busena],
  props: {
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      search: null,
      showUpload: false,

      modalUploadRefresh: 0,
      modalUpload: {},
      modalBylosRusys: [],
      rinkmenaDydis: null,
      salys: [],
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      bylos: [],
      bylos_rusys: [],
      bylos_segamos: false,
      zemes_sklypai: {
        bylos: [],
        bylos_rusys: [],
        gali_uzsakyti: false,
      },
      obj_dokumento_numeris: null,
      obj_dokumento_data: null,
      itemsPerPageOptions: [10, 50, -1],
      pageSize: 10,
    }
  },
  computed: {
    ...mapGetters(['prasymasID', 'prasymasTipas', 'prasymasReadonly']),
    isLocal() {
      return process.env.VUE_APP_LOCAL === 'local'
    },
    isReadonly() {
      return this.readonly
    },
    headers() {
      return [
        {
          text: this.$t('Dokumento tipas'),
          align: 'start',
          value: 'byl_rusis',
          hide: this.hideDokumentoTipas,
        },
        {
          text: this.$t('Dokumento pavadinimas'),
          align: 'start',
          value: 'byl_pavadinimas',
        },
        {
          text: this.$t('Užsakytas RC savitarnoje'),
          align: 'center',
          hide: this.hideUzsakytas,
          value: 'uzsakytasTxt',
          width: 100,
        },
        {
          text: '',
          align: 'center',
          sortable: false,
          value: 'actions',
          width: 50,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    itemsList() {
      return this.bylosList.concat(this.sklypaiList)
    },
    bylosList() {
      return this.bylos.map(item => {
        item.sklypas = false
        item.uzsakytas = null
        item.canUpload = false

        if (!item.byl_id) {
          item.byl_rusis = 'Rengiamas dokumentas'
          item.byl_pavadinimas = 'Rengiamas dokumentas.pdf'
          item.byl_tipas = 'preview_ntr'
          item.byl_url = `ntrpaslaugos/prasymas/${this.prasymasID}/perziura`
          item.canDownload = true
          item.canEdit = false
          item.canDelete = false
          return item
        }
        item.byl_tipas = 'download'
        item.byl_url = `ntrpaslaugos/byla/${item.byl_id}/${item.byl_hash}/content`
        item.canDownload = item.byl_pavadinimas != null
        item.canEdit = false //this.bylos_segamos && !this.isReadonly
        item.canDelete =
          (this.isRengiamas || this.isGrazintas) && !this.isReadonly
        return item
      })
    },
    sklypaiList() {
      return this.zemes_sklypai.bylos.map(item => {
        item.sklypas = true
        item.byl_rusis = 'Žemės sklypo planas'
        item.uzsakytas = item.byl_sugeneruota === 6
        item.uzsakytasTxt = item.uzsakytas ? this.$t('Taip') : this.$t('Ne')

        if (!item.byl_id) {
          item.byl_pavadinimas = ''
          item.canDownload = false
          item.canEdit = false
          item.canDelete = false
          item.canUpload = !this.isReadonly
          return item
        }

        item.byl_tipas = 'download'
        item.byl_url = `ntrpaslaugos/byla/${item.byl_id}/${item.byl_hash}/content`
        item.canDownload = item.byl_pavadinimas != null
        item.canEdit = false //this.bylos_segamos && !this.isReadonly
        item.canDelete =
          !item.uzsakytas &&
          (this.isRengiamas || this.isGrazintas) &&
          !this.isReadonly
        item.canUpload = false
        return item
      })
    },
    hideDokumentoTipas() {
      return this.isPrasymasPreliminari
    },
    hideUzsakytas() {
      return (
        !this.zemes_sklypai.gali_uzsakyti ||
        this.zemes_sklypai.bylos.length == 0
      )
    },
    pridetiColor() {
      return !this.turtas
    },
    modalUploadKey() {
      return 'upload' + this.modalUploadRefresh
    },
    hideFooter() {
      return this.itemsList.length <= this.pageSize
    },
    showAddRinkmenos() {
      return !this.isReadonly && this.bylos_rusys && this.bylos_rusys.length > 0
    },
    showUzsakytiSklypa() {
      return !this.isReadonly && this.zemes_sklypai.gali_uzsakyti
    },
  },
  beforeCreate() {
    this.$root.$off('reloadPrasymasUpload')
  },
  created() {
    this.$root.$on('reloadPrasymasUpload', () => {
      this.getData()
    })
    this.getData()
  },
  methods: {
    getData() {
      this.pageloading = true
      this.loading = true
      this.$axios
        .get(`ntrpaslaugos/prasymas/${this.prasymasID}/byla`)
        .then(res => {
          this.bylos = res.data.bylos
          this.bylos_rusys = res.data.bylos_rusys
          this.bylos_segamos = res.data.bylos_segamos
          this.zemes_sklypai = res.data.zemes_sklypai
          this.obj_dokumento_numeris = res.data.obj_dokumento_numeris
          this.obj_dokumento_data = res.data.obj_dokumento_data
          this.rinkmenaDydis = parseInt(res.data.rinkmena_dydis)
          this.$emit('updated')
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
        })
    },
    editItem(item) {
      this.openUpload(item)
    },
    newItem() {
      this.openUpload({
        // byl_dokumento_nr: this.obj_dokumento_numeris,
        // byl_dokumento_data: this.obj_dokumento_data,
      })
    },
    openUpload(item) {
      this.modalUpload = {
        ...item,
      }
      this.modalBylosRusys = item.sklypas
        ? this.zemes_sklypai.bylos_rusys
        : this.bylos_rusys
      this.modalUploadRefresh++
      this.showUpload = true
    },
    savedUpload() {
      this.getData()
    },
    deleteItem(item) {
      this.modalDeleteVardas = item.byl_pavadinimas
      this.modalDeleteItem = Object.assign({}, item)
      this.showDelete = true
    },
    confirmDelete(item) {
      this.loading = true

      this.$axios
        .delete(`ntrpaslaugos/prasymas/${this.prasymasID}/byla/${item.byl_id}`)
        .then(res => {
          window._VMA.$emit('DATA_OK', res.data.message)
          this.getData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    newZemesSklypas() {
      if (this.isLocal) {
        this.$router.push({
          name: 'pazymosZemesSklypas',
        })
        return
      }
      window.location.href = `${process.env.VUE_APP_SAVITARNA_GLOBAL_URL}goto.do?menuId=160`
    },
  },
}
</script>
